export default __webpack_public_path__ + "static/media/vitra_chair_04.d55842e3.png";